import * as z from "zod";

export const createGlobalMessageSchema = z
  .object({ id: z.number() })
  .nonstrict();
